// extracted by mini-css-extract-plugin
export default {"wrap":"To-z","logoContainer":"Uo-z","brandImg":"Vo-z","logoImg":"Wo-z","logoButton":"Xo-z"};